// extracted by mini-css-extract-plugin
export default {"emailDiv":"contact_emailDiv__2ehlV","emailImage":"contact_emailImage__eliLR","upworkImage":"contact_upworkImage__7Ay1f"};